import React from 'react'
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from './pages/Home'
import OurStory from './pages/OurStory'
import Culture from './pages/Culture'
import OurPhilosophy from './pages/OurPhilosophy'
import ContactUs from './pages/ContactUs';
import SEC from './pages/SEC'
import Digitalisation from "./pages/Digitalisation"
import Menswear from './pages/Menswear';
import Womenswear from './pages/Womenswear';
import Kidswear from './pages/Kidswear';
import PromotionalWear from './pages/PromotionalWear';
import Workwear from './pages/Workwear';
import Uniform from './pages/Uniform';
import Sportswear from './pages/Sportswear';
import HomeTextile from './pages/HomeTextile';
import Shoes from './pages/Shoes'
import ScrollToTop from './components/ScrollToTop';
import './index.css'


export default function App(){
return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/our-story" element={<OurStory />} />
        <Route path="/culture" element={<Culture />} />
        <Route path="/our-philosophy" element={<OurPhilosophy />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/sustainability-ethics-compliance" element={<SEC />} />
        <Route path="/digitalisation" element={<Digitalisation />} />
        <Route path="/menswear" element={<Menswear />} />
        <Route path="/womenswear" element={<Womenswear />} />
        <Route path="/kidswear" element={<Kidswear />} />
        <Route path="/promotional-wear" element={<PromotionalWear />} />
        <Route path="/workwear" element={<Workwear />} />
        <Route path="/uniform" element={<Uniform />} />
        <Route path="/sportswear" element={<Sportswear />} />
        <Route path="/home-textile" element={<HomeTextile />} />
        <Route path="/shoes" element={<Shoes />} />
      </Routes>
    </Router>
)
}